// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useContext, Fragment, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './index.module.less';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {perr, perr_www_visit} from 'hola_pub_util';
// @ts-ignore
import {Gradient} from '../../../../hola/pub/lib/gradient.js';
import {use_qs} from '../../../../hola/pub/lib/use_qs';
import {if_set} from 'zutil';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Map} from '../../ui/landings/map';
import {Faq_section} from '../../ui/toolip/faq_section';
import {Lottie} from '../../../../hola/pub/lib/lottie';
import {use_scrolled} from '../../../../hola/pub/ui_utils';
import {use_intercom} from '../../../../hola/pub/ui/intercom';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import anim_styles from '../../ui/animation.module.less';
import {Products_cards} from '../../ui/free_proxy/product_cards';
import {Step_cards} from '../../ui/free_proxy/step_cards';
import {Use_case_bubbless} from '../../ui/free_proxy/use_case_bubbless';
import {Review_slides} from '../../ui/landings/review_slides';
import hola_opt from 'hola_opt';
import {obj_to_arr} from '../../ui/use_cases/use_case_faq';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Input} from '../../../../hola/pub/lib/input';
import {Checkbox} from '../../../../hola/pub/lib/checkbox';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

const Logo = ()=>{
  return <Link className={styles.logo} to="/">
    <img src={toolip_img_url('toolip/logo_black.svg')}/>
  </Link>;
};

interface i_hero_props {
    lp_mode?: boolean;
    title?: string;
    title_tag?:string;
    subtitle?: string;
    cta?: string;
    after_cta?: string;
}

interface i_hero_editor_props {
    value: i_hero_props;
    on_change: (v:i_hero_props)=>void;
    on_cancel: ()=>void;
}

export const Gradient_hero_editor = (props: i_hero_editor_props)=>{
    const [state, set_state] = useState<i_hero_props>(props.value || {});
    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);
    return <div>
      <Input size={'sm'} label={'title (html)'} value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}/>
      <Title_header_select value={state.title_tag} on_select={v=>
        set_state({...state, title_tag: v})}/>
      <Input size={'sm'} label={'subtitle (html)'} value={state.subtitle || ''}
        on_change={v=>set_state({...state, subtitle: v})}/>
      <Input size={'sm'} label={'cta'} value={state.cta || ''}
        on_change={v=>set_state({...state, cta: v})}/>
      <Input size={'sm'} label={'after_cta'} value={state.after_cta || ''}
        on_change={v=>set_state({...state, after_cta: v})}/>
      <Checkbox checked={!!state.lp_mode}
        on_change={v=>set_state({...state, lp_mode: v})}/>
      <br/>
      <Button caption={'Save'} size={'sm'}
        on_click={()=>props.on_change(state)}/>
      <Button caption={'Cancel'} size={'sm'} on_click={()=>props.on_cancel()}/>
    </div>;
};

export const Gradient_hero = (props: i_hero_props)=>{
    const {lp_mode, title, title_tag, subtitle, cta, after_cta} = props;
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const qs = use_qs();
    const gradient_ref = useRef();
    const hero_ref = useRef<HTMLDivElement>();
    useEffect(()=>{
        if (!gradient_ref.current || !hero_ref.current)
            return;
        const vars = {};
        if_set(qs.color1 && '#'+qs.color1, vars, 'gradient-color-1');
        if_set(qs.color2 && '#'+qs.color2, vars, 'gradient-color-2');
        if_set(qs.color3 && '#'+qs.color3, vars, 'gradient-color-3');
        if_set(qs.color4 && '#'+qs.color4, vars, 'gradient-color-4');
        // if_set(qs.color5 && '#'+qs.color5, vars, 'gradient-color-5');
        // if_set(qs.color6 && '#'+qs.color6, vars, 'gradient-color-6');
        // if_set(qs.color7 && '#'+qs.color7, vars, 'gradient-color-7');
        // if_set(qs.color8 && '#'+qs.color8, vars, 'gradient-color-8');
        if_set(qs.gradient_op && +qs.gradient_op/100, vars, 'gradient_op');
        if_set(qs.animation_op && +qs.animation_op/100, vars, 'animation_op');
        if_set(qs.underlay_op && +qs.underlay_op/100, vars, 'underlay_op');
        if_set(qs.content_op && +qs.content_op/100, vars, 'content_op');
        if_set(qs.gradient_pos, vars, 'gradient_pos');
        if_set(qs.animation_pos, vars, 'animation_pos');
        if_set(qs.underlay_pos, vars, 'underlay_pos');
        Object.keys(vars).forEach(k=>{
            hero_ref.current.style.setProperty(`--${k}`, vars[k]);
        });
        if (qs.no_animation)
            return;
        const on_interact = ()=>{
            const gradient = new Gradient();
            // @ts-ignore
            gradient.initGradient('#gradient-canvas');
            window.removeEventListener('scroll', on_interact);
            window.removeEventListener('mousemove', on_interact);
        };
        window.addEventListener('scroll', on_interact);
        window.addEventListener('mousemove', on_interact);
    }, [gradient_ref.current, hero_ref.current]);
    const hero_cls = cn(styles.gradient_hero, {
        [styles.no_animation]: qs.no_animation,
    });
    return <div ref={hero_ref} className={hero_cls}>
      <canvas ref={gradient_ref} id="gradient-canvas" data-transition-in/>
      {lp_mode && <div className={styles.logo_container}>
        <div className={cn(theme.container)}><Logo/></div>
      </div>}
      <div className={cn(theme.container, styles.hero)}>
        <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
          <p className={cn(theme.mono14, styles.uptime)}>
            <Lottie autoplay loop width="20px" height="14px"
              src={toolip_img_url('animation/uptime.json')}/>
            <span><T>Uptime: <b>99.9%</b></T></span>
          </p>
        </div>
        <div className={styles.hero_text_wrapper}>
          {title ? <Dynamic_heading className={cn(styles.hero_title,
            anim_styles.hero_showup_2)}
            tag={title_tag}
            dangerouslySetInnerHTML={{__html: t(title)}}/>
          : <Dynamic_heading className={cn(styles.hero_title,
            anim_styles.hero_showup_2)}>
            <T>Start&nbsp; with a Free Proxy <br/>Plan Customized for You</T>
          </Dynamic_heading>}
          {subtitle ? <p className={cn(theme.u1, styles.hero_text,
            anim_styles.hero_showup_2)}
            dangerouslySetInnerHTML={{__html: t(subtitle)}}/>
          : <p className={cn(theme.u1, styles.hero_text,
            anim_styles.hero_showup_2)}><T>Get Instant Access and Enjoy Your
              Free Proxy Plan</T></p>}
          {lp_mode ?
            <div className={styles.buttons_wrap}>
              <Button caption={t(cta || 'Try now for free')} size={'lg'}
                no_jump to={'/dashboard'} fit
                on_click={()=>{
                  perr({id: 'toolip_homepage_get_started_top_click'});
                }}
                cls={cn(styles.hero_cta, anim_styles.hero_showup_3)}
              />
            </div>
          :
            <Button caption={
              <Fragment><T>Start your free trail</T> <Icon_arrow_right/>
                </Fragment>}
              size={'lg'} no_jump to={'/dashboard'} fit
              on_click={()=>{
                perr({id: 'toolip_homepage_get_started_top_click'});
              }} cls={cn(styles.hero_cta, anim_styles.hero_showup_3)}
            />
          }
          <p className={cn(theme.p4, theme.med, styles.hero_cta_text,
            anim_styles.hero_showup_3)}>
              <T>{after_cta || 'No credit card required'}</T>
          </p>
        </div>
      </div>
    </div>;
};

interface i_global_props {
    no_bg?: boolean;
    title?: string;
    title_tag?: string;
    subtitle?: string;
    cls?: string;
}

export const HP_global = ({no_bg, title, title_tag,
  subtitle, cls=''}: i_global_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <section className={cn(styles.hp_global, {[styles.no_bg]: no_bg},
      cls)}>
      <div className={cn(theme.container, styles.container)}>
      <Dynamic_heading tag={title_tag || 'h2'}>
        {title || 'Truly Global Network'}
      </Dynamic_heading>
        <p className={theme.u1}><T>{subtitle ||
          'Choose from 70+ million Proxies in 195 countries'}</T></p>
        <div className={styles.map}>
          <Map key={'homepage'} shown_in_home={true}/>
        </div>
      </div>
    </section>;
};

export const HP_global_editor = ({value, on_change} : {
  value: i_global_props;
  on_change: (v:i_global_props)=>void
})=>{
  return <div>
    <Input
      value={value.title || ''}
      on_change={v=>on_change({...value, title: v})}
      label={'Section Title'}
    />
    <Title_header_select value={value.title_tag} on_select={v=>
      on_change({...value, title_tag: v})}/>
    <Input
      value={value.subtitle || ''}
      on_change={v=>on_change({...value, subtitle: v})}
      label={'Section Subtitle'}
    />
    <div style={{display: 'flex', alignItems: 'center', marginTop: '8px'}}>
      <input
        type="checkbox"
        checked={!!value.no_bg}
        onChange={e=>on_change({...value, no_bg: e.target.checked})}
        id="no_bg_checkbox"
      />
      <label htmlFor="no_bg_checkbox" style={{marginLeft: '8px'}}>
        Remove Background
      </label>
    </div>
  </div>;
};

const HP_faq = ()=>{
    const {theme} = useContext(Settings_context);
    const collection =
      hola_opt.intercom_articles?.['FAQ']?.['Free Proxy']
      || [];
    return <div className={cn(styles.hp_faq, theme.container)}>
      <Faq_section color="transparent"
        custom_questions={obj_to_arr(collection)}/>
    </div>;
};

export const HP_final = ()=>{
    const {T} = use_translation_v({no_defaults: true});
    return <div className={styles.hp_final}>
      <div className={styles.bg}/>
      <div className={styles.container}>
        <h2><T>Get the right Proxies.</T><br/>
          <T>Get ahead.</T></h2>
        <Button caption={<Fragment><T>Start your free trial</T>
          <Icon_arrow_right/></Fragment>}
          size={'lg'} no_jump cls={styles.last_btn} to={'/dashboard'} fit
          round={false} on_click={()=>{
            perr({id: 'toolip_homepage_get_started_bottom_click'});
          }}/>
      </div>
    </div>;
};

export const Root = ()=>{
    const {t} = use_translation_v({no_defaults: true});
    useEffect(()=>{
        perr_www_visit({id: 'toolip_free_proxy_visit'});
    }, []);
    const {y} = use_scrolled();
    const ref = useRef<HTMLDivElement>();
    const {width} = use_screen();
    const intercom = use_intercom(false);
    useEffect(()=>{
        if (!ref.current)
            return;
        ref.current.style.setProperty('--y', `${y}px`);
    }, [y, ref.current]);
    useEffect(()=>{
        if (width >= 768 && !intercom.visible)
            intercom.show();
        if (width < 768)
            intercom[y > 500 ? 'show' : 'hide']();
    }, [y, width, intercom.visible]);
    return <div className={styles.root_ind} ref={ref}>
      <Gradient_hero lp_mode={false}/>
      <Products_cards
        title={t('The toolip Products')}
        subtitle=
          {t('Choose what best matches your needs and goals on the house!')}
        />
      <Step_cards />
      <Use_case_bubbless/>
      <HP_global/>
      <Review_slides/>
      <HP_faq/>
      <HP_final/>
    </div>;
};

const meta: any = {
    meta: ({translate})=>{
        translate = translate ? translate : t=>t;
        return {
            title: translate('Start with a Free Proxy Plan Customized for You '
                +'Try Now For Free'),
            description: translate('Discover premium proxies pocket friendly '
                +'prices - try now for free benefits.'),
            canonical_url: 'https://toolip.io/free-proxy'
        };
    },
    footer_opt: {
        gradient_color: 'var(--wp--preset--color--blue-100)',
    },
    translation: {
        enabled: true,
        detect_by_country: true,
        white_list: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh']
    },
};

Root.meta = meta;
